export default __webpack_public_path__ + "static/media/filterArrowIcon.4cc879b3.svg";